export const STORAGE_KEYS = {
  USER_PREFERENCES: 'sanctum-preferences',
  GAME_PROGRESS: 'sanctum-progress',
  AUTH_TOKEN: 'sanctum-auth',
} as const;

export const API_ENDPOINTS = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001',
  AUTH: '/auth',
  GAME: '/game',
  USER: '/user',
} as const;

export const GAME_CONFIG = {
  MAX_WIDTH: 430,
  MIN_HEIGHT: 600,
  ASPECT_RATIO: 9 / 16,
} as const;
